<!-- Sidebar module — Carot ERP v2 (sales-shell.jsx :: SalesSidebar, EP-UI-02 / US-UI-22).
     Rộng 234 / thu gọn 62 (biến --shell-sidebar-*), nền trắng, viền phải hairline. Mọi màu qua
     token nên KHÔNG có biến thể `dark:` thủ công. Mục đang chọn = hồng nhạt (Alex chốt 30/10). -->
<aside
  class="ctx-sidebar"
  [class.ctx-sidebar--collapsed]="collapsed"
  role="navigation"
  aria-label="Module sub-navigation"
>
  <!-- Đầu: ô icon 28 nền ink + tên module + dòng phụ (tenant) + nút thu gọn. -->
  <div class="ctx-sidebar-head">
    <span class="ctx-sidebar-mark" aria-hidden="true">
      <span class="material-symbols-outlined">{{ activeModuleIcon || 'apps' }}</span>
    </span>
    @if (!collapsed) {
      <div class="ctx-sidebar-titles">
        <h1 class="ctx-sidebar-title">
          {{ activeModuleTitle || 'Navigation.Home' | translate }}
        </h1>
        @if (tenantName) {
          <span class="ctx-sidebar-sub">{{ tenantName }}</span>
        }
      </div>
    }
    <button
      type="button"
      class="ctx-sidebar-toggle"
      (click)="toggle()"
      [attr.aria-expanded]="!collapsed"
      [attr.aria-label]="(collapsed ? 'Navigation.Expand' : 'Navigation.Collapse') | translate"
      [dsTooltip]="(collapsed ? 'Navigation.Expand' : 'Navigation.Collapse') | translate"
      [dsTooltipPosition]="'right'"
    >
      <span class="material-symbols-outlined" aria-hidden="true">
        {{ collapsed ? 'chevron_right' : 'chevron_left' }}
      </span>
    </button>
  </div>

  <div class="ctx-sidebar-list no-scrollbar">
    @if (currentSubNav.length > 0) {
      @for (item of currentSubNav; track item.path; let first = $first) {
        <ng-container *hasResource="item.resourceId">
          @if (item.section) {
            @if (collapsed) {
              @if (!first) {
                <div class="ctx-nav-divider" aria-hidden="true"></div>
              }
            } @else {
              <!-- Tiêu đề NHÓM viết hoa bằng CSS (text-transform) — giá trị i18n giữ sentence
                   case. Đây là nhãn nhóm điều hướng, không phải nhãn trường. -->
              <div class="ctx-nav-section" [class.ctx-nav-section--first]="first">
                <span class="ctx-nav-section-label truncate">{{ item.section | translate }}</span>
                @if (item.sectionCount !== undefined) {
                  <span class="ctx-nav-section-count">{{ item.sectionCount }}</span>
                }
              </div>
            }
          }
          <a
            [routerLink]="item.path"
            [queryParamsHandling]="'preserve'"
            class="ctx-nav-item"
            [class.ctx-nav-planned]="item.status === 'planned'"
            [class.ctx-nav-active]="item.path === activeNavPath"
            [class.ctx-nav-locked]="isLocked(item)"
            [attr.aria-current]="item.path === activeNavPath ? 'page' : null"
            [attr.aria-label]="collapsed ? (item.label | translate) : null"
            [dsTooltip]="collapsed ? (item.label | translate) : ''"
            [dsTooltipPosition]="'right'"
          >
            <span class="material-symbols-outlined" aria-hidden="true">
              {{ navIcon(item) }}
            </span>
            @if (!collapsed) {
              <span class="ctx-nav-label">{{ item.label | translate }}</span>
              @if (item.status === 'planned') {
                <span class="ctx-nav-plan-chip">PLAN</span>
              } @else if (item.count !== undefined) {
                <span class="ctx-nav-badge">{{ item.count }}</span>
              } @else if (item.badge) {
                <span class="ctx-nav-badge">{{ item.badge }}</span>
              }
            }
          </a>
        </ng-container>
      }
    } @else if (!collapsed) {
      <div class="ctx-sidebar-empty">
        {{ 'Navigation.NoSubNavigation' | translate }}
      </div>
    }
  </div>

  <!-- Chân: "App Version vX · môi trường" (sales-shell.jsx). -->
  @if (!collapsed) {
    <div class="ctx-sidebar-foot">
      App Version v{{ appVersion }} · {{ isProduction ? 'Production' : 'Development' }}
    </div>
  }
</aside>
